import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';
import { UI_EventList } from 'ui/components/3-organisms/EventList/EventList';

export const EventList = ({ content }: Content.EventList) => {
	const { title, events, link } = content ?? {};
	const dictionary = useDictionaryContext();
	if (!events) return null;
	return (
		<CludoComment>
			<UI_EventList
				heading={title}
				items={events?.map((event) => {
					return {
						...event,
						date: {
							...event.date,
							label: dictionary?.getEvent('Date'),
						},
						location: {
							...event.location,
							label: dictionary?.getEvent('Location'),
						},
						price: {
							...event.price,
							label: dictionary?.getEvent('Price'),
						},
						link: { ...event.link, name: dictionary.getEvent('MoreInfo') },
					};
				})}
				link={link}
			/>
		</CludoComment>
	);
};
